import { formatAmount } from "@loot-os/api-contract";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@loot-os/ui/components/table";

import { amountColumnHeader, useCurrency } from "../lib/currency";
import { formatDate } from "../lib/format";
import type { UserDetail } from "../lib/trpc";
import { TableMessageRow } from "./TableMessageRow";

const COLUMNS = 5;

/** The latest box opens from `users.get`: the item rolled, its value, what the open cost. */
export function UserOpensTab({ rows }: { rows: UserDetail["opens"] }) {
  const currency = useCurrency();
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Time</TableHead>
          <TableHead>Item</TableHead>
          <TableHead className="text-right">{amountColumnHeader("Value", currency)}</TableHead>
          <TableHead className="text-right">{amountColumnHeader("Cost", currency)}</TableHead>
          <TableHead className="text-right">Nonce</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.length === 0 && <TableMessageRow colSpan={COLUMNS}>No opens yet.</TableMessageRow>}
        {rows.map((open) => (
          <TableRow key={open.id}>
            <TableCell className="text-muted-foreground">{formatDate(open.createdAt)}</TableCell>
            <TableCell>{open.item.name}</TableCell>
            <TableCell className="text-right font-mono text-xs">
              {formatAmount(open.item.value, currency)}
            </TableCell>
            <TableCell className="text-right font-mono text-xs">
              {formatAmount(open.costCents, currency)}
            </TableCell>
            <TableCell className="text-right font-mono text-xs">{open.nonce}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
